import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { Heart, Trash2 } from "lucide-react";

export default function Wishlist() {
  const { items, remove } = useWishlist();
  return (
    <div className="pt-32 pb-20" data-testid="wishlist-page">
      <div className="container-x">
        <p className="label-small">Saved for Later</p>
        <h1 className="font-serif text-5xl text-[#2D2424] mt-3">Your Wishlist</h1>
        {items.length === 0 ? (
          <div className="text-center py-20" data-testid="wishlist-empty">
            <Heart className="w-12 h-12 mx-auto text-[#7A1F2B]" strokeWidth={1}/>
            <p className="font-serif text-2xl mt-4">No saved hampers yet</p>
            <Link to="/shop/her" className="btn-primary mt-6 inline-flex">Browse Collection</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
            {items.map((it) => (
              <div key={it.id} className="bg-white border border-[#E5DBD8] flex gap-4 p-4" data-testid={`wish-item-${it.id}`}>
                <Link to={`/product/${it.slug}`} className="w-24 h-24 bg-[#F2E8E4] shrink-0">
                  <img src={it.image} alt={it.name} className="w-full h-full object-cover"/>
                </Link>
                <div className="flex-1">
                  <Link to={`/product/${it.slug}`} className="font-serif text-lg hover:text-[#7A1F2B]">{it.name}</Link>
                  <p className="text-[#7A1F2B] mt-1">₹{it.price.toLocaleString("en-IN")}</p>
                  <button onClick={() => remove(it.id)} className="mt-3 text-xs text-[#7A1F2B] hover:text-[#5C1520] inline-flex items-center gap-1"><Trash2 className="w-3 h-3"/> Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
